"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = require("lodash");

var Styled = _interopRequireWildcard(require("./Summary.style"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var Summary = function Summary(_a) {
  var errors = _a.errors,
      summaryHeader = _a.summaryHeader,
      summaryTitle = _a.summaryTitle;
  var summaryRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    summaryRef.current && summaryRef.current.focus();
  }, []);

  var errorClick = function errorClick(e) {
    e.preventDefault();
    var href = e.target.href;
    var id = href.substring(href.indexOf('#') + 1, href.length);
    document.getElementById(id).focus();
  };

  return _react.default.createElement(Styled.SummaryBox, {
    "data-testid": "summary",
    ref: summaryRef,
    role: "group",
    tabIndex: -1
  }, _react.default.createElement(Styled.SummaryHeader, {
    as: summaryHeader
  }, summaryTitle), _react.default.createElement(Styled.ErrorList, null, (0, _lodash.map)(errors, function (error, key) {
    return _react.default.createElement(Styled.ErrorItem, {
      key: key
    }, _react.default.createElement(Styled.ErrorLink, {
      as: "a",
      color: "black",
      "data-testid": "errorLink__" + key,
      href: "#" + key,
      onClick: errorClick
    }, error));
  })));
};

Summary.displayName = 'Summary';
var _default = Summary;
exports.default = _default;